import { useNavigate, useParams } from "react-router-dom";
import { api } from "../api/client";
import { useAsync } from "../lib/useAsync";
import { useAuth } from "../auth/AuthContext";
import { useState } from "react";

export function JoinTeam() {
  const { code = "" } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated, login } = useAuth();
  const { data, loading, error } = useAsync(
    () => api.resolveJoinCode(code),
    [code],
  );
  const [msg, setMsg] = useState<string>();

  const join = async () => {
    setMsg(undefined);
    try {
      await api.joinTeam(code);
      navigate("/teams");
    } catch (e) {
      setMsg((e as Error).message);
    }
  };

  if (loading) return <p>Loading…</p>;
  if (error) return <p className="error">{error}</p>;

  return (
    <div className="card">
      <h1>Join {data?.name}</h1>
      <p className="muted">You've been invited to join this team.</p>
      {isAuthenticated ? (
        <button onClick={join}>Join team</button>
      ) : (
        <div className="row">
          <button onClick={() => login()}>Sign in to join</button>
          <button className="secondary" onClick={() => login("Google")}>
            Sign in with Google
          </button>
        </div>
      )}
      {msg && <p className="error">{msg}</p>}
    </div>
  );
}
